import { api } from '@smena/ui';

export interface CalendarProperty {
  id: string;
  title: string;
  city: string | null;
}

export interface CalendarBooking {
  id: string;
  propertyId: string;
  guestId: string | null;
  guestName: string;
  checkin: string;
  checkout: string;
  status: string;
  source: string;
  prepaid: boolean;
  amount: number;
}

export interface CalendarView {
  from: string;
  to: string;
  properties: CalendarProperty[];
  bookings: CalendarBooking[];
}

export async function fetchCalendar(from: string, to: string): Promise<CalendarView> {
  const q = new URLSearchParams({ from, to }).toString();
  return api<CalendarView>(`/api/staff/calendar?${q}`);
}

export async function patchBooking(
  id: string,
  patch: Partial<{
    checkin: string;
    checkout: string;
    amount: number;
    prepaid: boolean;
    guestName: string;
    guestPhone: string | null;
    guestsCount: number | null;
    notes: string | null;
    status: string;
  }>,
): Promise<unknown> {
  return api(`/api/staff/bookings/${id}`, { method: 'PATCH', json: patch });
}

export async function cancelBooking(id: string): Promise<{ id: string; status: string }> {
  return api(`/api/staff/bookings/${id}/cancel`, { method: 'POST', json: {} });
}
